import AboutMeCard from '@molecules/AboutMeCard';
import Breadcrumbs from '@molecules/Breadcrumbs';
import ColumnLayout from '@molecules/ColumnLayout';
import InstagramPreview from '@organisms/InstagramPreview';
import ListingCard from '@organisms/ListingCard';
import type { ReactElement } from 'react';

import { usePagination } from '@/hooks/pagination.hook';
import {
  CardWrapper,
  MaxWidthWrapper,
  MobileCardsWrapper,
} from '@/styles/GlobalStyle';

import {
  ListingBreadcrumbsWrapper,
  ListingSubtitle,
  ListingTitle,
  ListingTitleWrapper,
} from './ArticleListView.styled';
import type { ArticleListViewProps } from './ArticleListView.types';

export const ArticleListView = ({
  posts,
  currentCategory,
  columnLayout,
  breadcrumbs,
}: ArticleListViewProps): ReactElement => {
  const promotedCategory =
    currentCategory?.toLowerCase().includes('poradnik') ||
    currentCategory?.toLowerCase().includes('life');
  usePagination({
    posts,
  });

  return (
    <>
      <MaxWidthWrapper>
        {!currentCategory?.toLowerCase().includes('life') && (
          <ListingBreadcrumbsWrapper>
            <Breadcrumbs {...breadcrumbs} />
          </ListingBreadcrumbsWrapper>
        )}
      </MaxWidthWrapper>
      <ListingTitleWrapper>
        <ListingSubtitle>
          {promotedCategory ? 'Kategoria' : 'Kierunek'}
        </ListingSubtitle>
        <ListingTitle>{currentCategory}</ListingTitle>
      </ListingTitleWrapper>
      <ColumnLayout {...columnLayout} hideBreadcrumbs>
        {posts?.map((post, index) => {
          if (!post.image.src) return;
          return (
            <CardWrapper key={post.link}>
              <ListingCard priority={index <= 3} {...post} />
            </CardWrapper>
          );
        })}
        {/*<Pagination*/}
        {/*  currentPage={currentPage}*/}
        {/*  totalPages={totalPages}*/}
        {/*  onPageChange={({ selected }) => changePage(selected)}*/}
        {/*/>*/}
        <MobileCardsWrapper>
          <AboutMeCard />
          <InstagramPreview {...columnLayout?.instagramFeed} />
        </MobileCardsWrapper>
      </ColumnLayout>
    </>
  );
};
